<template>
  <div class="w-100">
    <template v-if="round.matches">
      <TheMatchDetailRow
        v-for="match in round.matches"
        :key="match.id"
        :match="match"
      />
    </template>
    <BaseAlert v-else>
      {{ $t('there-are-no-passed-matches-in-this-round') }}
    </BaseAlert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TheMatchDetailRow from '@/components/Molecules/TheMatchDetailRow'
import BaseAlert from '@/components/Atoms/BaseAlert'

export default {
  name: 'PastMatches',
  components: {
    BaseAlert,
    TheMatchDetailRow,
  },
  computed: {
    ...mapState({
      round: state => state['rounds/history/round'].round,
    }),
  },
}
</script>
